module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAAAXNSR0IArs4c6QAAAHlJREFUKFOlksENwkAMBGfrgl8C/1SBFJ6hARCiiPQBPSBRAQXQxqCTQMrzTvF7x16vHSpLvQOXJM8/kkoWdQBmYJPkXbhquIjVETgB2ySfJvjX4AbsgD7qtdb6QncAXuvg1qlqsb0Huqad1SMwNQe26lTqAzgvn+QLn5svi716F/QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/ArrowSelection.png
// module id = tEQ7
// module chunks = 44